import { gsap } from 'gsap/all'
import { getColorMode, hexToRgb } from 'helpers'

export const brandBanner = (target) => {
  const el = {
    backgroundColor: target.querySelector('[data-color-top]'), // this way it can target both brand & featured banners - previously .brand-banner__background-color
  }

  const color = {
    top: el.backgroundColor.dataset.colorTop,
    bottom: el.backgroundColor.dataset.colorBottom,
  }

  const method = {
    init: () => {
      method.checkContrast()
      method.setBackgroundColor()
    },

    setBackgroundColor: () => {
      gsap.set(el.backgroundColor, {
        background: `linear-gradient(180deg, ${color.top} 0%, ${color.bottom} 100%)`,
      })
    },

    checkContrast: () => {
      const colorTopMode = getColorMode(hexToRgb(color.top))
      const colorBottomMode = getColorMode(hexToRgb(color.bottom))

      if (colorTopMode === 'dark' || colorBottomMode === 'dark') {
        target.dataset.theme = 'dark'
      }
    },
  }

  method.init()
}
